/**
 * @Description
 */

import { FC } from 'react';
import styles from '../entry.module.less';

const Footer:FC<any> = ({ qrCode }) => {
  return (
    <div className={styles['footer']}>
      <div className={styles['footer-title']}>{`扫码查看配套分布>`}</div>
      <img src={qrCode} className={styles['footer-code']}/>
    </div>
  );
};

export default Footer;
